import React from 'react'

import notification from 'common/components/feedback/Notification'

import JobLogs from './jobLogs/index'

export const SCHEDULED_JOBS_PATH = 'scheduled-jobs'

const ScheduledJobs: React.FC = () => {
  return (
    <>
      <JobLogs />
    </>
  )
}

export default ScheduledJobs
